export const bulk = () => (
  <path
    d="M3 12h10M3 6h18M3 18h6m9.5-5.5a2.121 2.121 0 013 3L16 21h-3v-3l5.5-5.5z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
